var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.478 19.5a1 1 0 0 1 .117 1.993l-.117.007h-2.957a1 1 0 0 1-.117-1.993l.117-.007h2.957zm-1.479-17 .325.008a6.544 6.544 0 0 1 6.226 6.535v3.329l.964.965a3.01 3.01 0 0 1 .879 1.96l.006.21-.008.186A2.9 2.9 0 0 1 17.5 18.36l-10.992-.003c-1.598 0-2.895-1.293-2.899-2.94l.011-.22a3.004 3.004 0 0 1 .873-1.86l.966-.968V9.043a6.544 6.544 0 0 1 6.306-6.539l.234-.004zm-.01 1.999-.202.006a4.544 4.544 0 0 0-4.328 4.538v3.74a1 1 0 0 1-.293.707l-1.261 1.262a.99.99 0 0 0-.29.58l-.007.127a.9.9 0 0 0 .9.897l10.992.003c.47 0 .86-.362.895-.787l.005-.106c0-.267-.107-.523-.298-.713l-1.26-1.26a1 1 0 0 1-.292-.707V9.043a4.544 4.544 0 0 0-4.299-4.537L11.99 4.5z",
    fill: "#98F2F8",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBell);
export default __webpack_public_path__ + "static/media/icons-bell.6c8db5c84ea6cbadeb7c96b7f5bb3713.svg";
export { ForwardRef as ReactComponent };